export enum PickupChoice {
    AtHome = "Ritiro a domicilio",
    TNTPoint = "Consegna in FedEx TNT Point",
}